import { render } from "./VabeneInfoFranchisePage.vue?vue&type=template&id=544c1d1d&scoped=true&ts=true"
import script from "./VabeneInfoFranchisePage.vue?vue&type=script&lang=ts"
export * from "./VabeneInfoFranchisePage.vue?vue&type=script&lang=ts"

import "./VabeneInfoFranchisePage.vue?vue&type=style&index=0&id=544c1d1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544c1d1d"]])

export default __exports__